import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaEdit, FaTrash, FaEye } from 'react-icons/fa';
import Pagination from '../../components/Pagination';

const ImoveisTab = ({
  imoveis,
  pesquisaImoveis,
  setPesquisaImoveis,
  loadingTable,
  filtrarImoveis,
  agruparImoveisPorCodigo,
  handleEditImovel,
  handleDeleteImovel,
  handleDeleteTodasUnidades,
  setShowImovelModal,
  loadTags,
  pageImoveis,
  setPageImoveis,
  itemsPerPageImoveis,
  setItemsPerPageImoveis
}) => {
  const navigate = useNavigate();
  
  // Obter imóveis filtrados e agrupados
  const imoveisFiltrados = filtrarImoveis(imoveis);
  const imoveisAgrupados = agruparImoveisPorCodigo(imoveisFiltrados);
  const codigos = Object.keys(imoveisAgrupados).sort();
  
  // Resetar página quando pesquisa mudar
  React.useEffect(() => {
    setPageImoveis(1);
  }, [pesquisaImoveis, setPageImoveis]);
  
  // Paginar códigos (cada código pode representar 1 ou mais imóveis)
  const startIndex = (pageImoveis - 1) * itemsPerPageImoveis;
  const endIndex = startIndex + itemsPerPageImoveis;
  const codigosPaginados = codigos.slice(startIndex, endIndex);

  return (
    <div className="dashboard-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h2>Gerenciar Imóveis</h2>
        <button className="btn-add" onClick={() => { loadTags(); setShowImovelModal(true); }}>
          <FaPlus /> Adicionar Imóvel
        </button>
      </div>
      
      {/* Campo de pesquisa */}
      <div style={{ marginBottom: '1rem' }}>
        <input
          type="text"
          placeholder="Pesquisar imóveis (código, tipo, bairro, cidade...)"
          value={pesquisaImoveis}
          onChange={(e) => setPesquisaImoveis(e.target.value)}
          style={{
            width: '100%',
            padding: '0.75rem',
            border: '1px solid #ddd',
            borderRadius: '5px',
            fontSize: '0.9rem'
          }}
        />
      </div>
      
      {loadingTable ? (
        <div className="loading">Carregando imóveis...</div>
      ) : (
        <div className="imoveis-table">
          <table>
            <thead>
              <tr>
                <th>Código</th>
                <th>Tipo</th>
                <th>Bairro</th>
                <th>Cidade</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {codigos.length === 0 ? (
                <tr>
                  <td colSpan="5" className="no-data">
                    Nenhum imóvel encontrado
                  </td>
                </tr>
              ) : (
                codigosPaginados.map(codigo => {
                  const imoveisDoCodigo = imoveisAgrupados[codigo];
                  const primeiroImovel = imoveisDoCodigo[0];
                  const quantidade = imoveisDoCodigo.length;
                  
                  return (
                    <tr key={codigo} style={{ backgroundColor: quantidade > 1 ? '#fff9e6' : 'transparent' }}>
                      <td>
                        {codigo}
                        {primeiroImovel.unidade && (
                          <span style={{ marginLeft: '0.25rem', color: '#666' }}>– {primeiroImovel.unidade}</span>
                        )}
                        {quantidade > 1 && (
                          <span style={{ marginLeft: '0.5rem', fontSize: '0.85rem', color: '#666' }}>
                            ({quantidade} imóveis)
                          </span>
                        )}
                      </td>
                      <td>{primeiroImovel.tipo}</td>
                      <td>{primeiroImovel.bairro}</td>
                      <td>{primeiroImovel.cidade}</td>
                      <td>
                        <div className="actions">
                          {quantidade > 1 ? (
                            <>
                              {imoveisDoCodigo.map((imovel, idx) => (
                                <button
                                  key={imovel.id}
                                  onClick={() => handleEditImovel(imovel)}
                                  className="btn-action btn-edit"
                                  title={`Editar Imóvel ${idx + 1}`}
                                  style={{ marginRight: '0.25rem' }}
                                >
                                  <FaEdit /> {idx + 1}
                                </button>
                              ))}
                              <button
                                onClick={() => handleDeleteTodasUnidades(codigo)}
                                className="btn-action btn-delete"
                                title="Excluir todas as unidades"
                                style={{ marginLeft: '0.5rem' }}
                              >
                                <FaTrash /> Todas
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                onClick={() => navigate(`/imovel/${primeiroImovel.id}`)}
                                className="btn-action btn-view"
                                title="Visualizar"
                              >
                                <FaEye />
                              </button>
                              <button
                                onClick={() => handleEditImovel(primeiroImovel)}
                                className="btn-action btn-edit"
                                title="Editar"
                              >
                                <FaEdit />
                              </button>
                              <button
                                onClick={() => handleDeleteImovel(primeiroImovel.id)}
                                className="btn-action btn-delete"
                                title="Excluir"
                              >
                                <FaTrash />
                              </button>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
          
          {codigos.length > 0 && (
            <Pagination
              currentPage={pageImoveis}
              totalItems={codigos.length}
              itemsPerPage={itemsPerPageImoveis}
              onPageChange={setPageImoveis}
              onItemsPerPageChange={setItemsPerPageImoveis}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ImoveisTab;


